var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page font-p page-accessibility"},[_c('div',{staticClass:"page-wrap"},[_c('app-page-header'),_c('app-page-body'),_c('app-page-footer')],1),_c('app-top-button'),_c('app-header-stamp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }